import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnnouncementComponent } from './announcement/announcement.component';
import { AddUpdateAnnouncementComponent } from './add-update-announcement/add-update-announcement.component';

const routes: Routes = [
  {
    path: '',
    component: AnnouncementComponent,
  },
  {
    path: 'add',
    component: AddUpdateAnnouncementComponent,
  },
  {
    path: 'update/:id',
    component: AddUpdateAnnouncementComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AnnouncementRoutingModule {}
